import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useFeatureFlagEnabled } from "posthog-js/react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "~/atoms/form";
import { Input } from "~/atoms/input";
import { featureFlags } from "~/config/featureFlags";
import { type DocumentEditFormValues } from "~/hooks/useDocumentEditForm";

export const DocumentReferenceNumberField = () => {
  const { t } = useTranslation();
  const isRefNumEnabled = useFeatureFlagEnabled(featureFlags.referenceNumber);
  const form = useFormContext<DocumentEditFormValues>();

  if (!isRefNumEnabled) {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name="referenceNumber"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t("commons.document.referenceNumber")}</FormLabel>
          <FormControl>
            <Input
              maxLength={50}
              value={field.value ?? ""}
              onChange={(e) => field.onChange(e.target.value || null)}
              placeholder={t("commons.document.referenceNumber")}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
